import * as React from 'react';
import TextureItem from './TextureItem';
import {Droppable, Draggable} from 'react-beautiful-dnd';
//import ComponentSlider from "@kapost/react-component-slider";
import {useState, useEffect} from 'react';

/*const renderLeftArrow = () => <i className="fa fa-caret-left" />;
const renderRightArrow = () => <i className="fa fa-caret-right" />;*/

function TexturesCollection(props) {
    const [orientationAngle, setOrientationAngle] = useState(0);

    useEffect(()=> {
        const onOrientationChange = (event) => {
            setOrientationAngle(event.target.screen.orientation.angle);
        };
        window.addEventListener("orientationchange", onOrientationChange);

        return() => {
            window.removeEventListener("orientationchange", onOrientationChange);
        }
    }, []);

    const collection =
        <Droppable droppableId={props.droppableId} isDropDisabled={true} direction={`${orientationAngle === 0 ? "horizontal" : "vertical"}`}>
            {(provided) => (
                <div ref={provided.innerRef} className='texturesInnerContainer row mx-auto'>
                    {/*<ComponentSlider
                        renderLeftArrow={renderLeftArrow}
                        renderRightArrow={renderRightArrow}
                    >*/}
                    {props.textures.map((item, index) =>
                        <Draggable key={item.id} draggableId={item.id} index={index}>
                            {(provided, snapshot) => (
                                <div className='wrapper'>
                                    <div className={`textureItemContainer ${(`ontouchstart` in document.documentElement) ? ' touch' : ' no-touch'}`}
                                         ref={provided.innerRef}
                                         {...provided.draggableProps}
                                         {...provided.dragHandleProps}>
                                        <TextureItem
                                            dataProvider={item}
                                            onTextureClick={props.onTextureClick.bind(this, item)}
                                        />
                                    </div>
                                </div>
                            )}
                        </Draggable>
                    )}
                    {/*</ComponentSlider>*/}
                    {provided.placeholder}
                </div>
            )}
        </Droppable>;

    return (
        <div id='texturesContainer' className='commonContainer row mx-auto'>
            {collection}
        </div>
    );
}
export default TexturesCollection;
